/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientPhoneRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'



/** @type {import('Simple/types.js').View} */
export default function PatientPhoneRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/PatientPhoneRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Patient's Phone Number"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/PatientPhone")}
 isSelected={flow.has("/App/Form/Data/ProvideData/PatientPhone")}
 text={text}
/>
{children}
</React.Fragment>)
}